import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-photography',
  templateUrl: './photography.component.html',
  styleUrls: ['./photography.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class PhotographyComponent implements OnInit {
  image: any;
    constructor(
        //private subCategoryImages: ImageService,
        private titleService: Title
        ) {
         this.titleService.setTitle('Alexander Koenig - Fotografie');

        }

    ngOnInit() {
       /* this.subCategoryImages.ImageData().subscribe((data) => {
            for (let i = 0; i < data.length; i++) {
                const cat = data[i];
                if (this.subcategory.find((c) =>
                    c.category === cat.category &&
                    c.name === cat.name &&
                    c.image1 === cat.image1 &&
                    c.image2 === cat.image2 &&
                    c.image3 === cat.image3 &&
                    c.image4 === cat.image4 &&
                    c.image5 === cat.image5 &&
                    c.image6 === cat.image6
                ) === undefined) {
                    this.subcategory.push({
                        category: cat.category,
                        name: cat.name,
                        image1: cat.image1,
                        image2: cat.image2,
                        image3: cat.image3,
                        image4: cat.image4,
                        image5: cat.image5,
                        image6: cat.image6
                    });
                }
            }
        });
        */
    }

}
